<template>
    <button :type="type" class="btn btn-outline-secondary">
        <i class="bi" :class="icon"></i>
        {{ text }}
    </button>
</template>

<script>
export default {
    name: 'ButtonDomRemove',
    props: {
        text: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: 'bi-x',
        },
        type: {
            type: String,
            default: 'button',
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
